export default __webpack_public_path__ + "static/media/gem-au-card.bbd1cdab.svg";